import { MessageSquare, Mail } from 'lucide-react';
import { useChatContext } from '../context/ChatContext';
import Button from '../components/Button';

function AssistantSection() {
  const { openChat } = useChatContext();

  return (
    <section
      id="assistent"
      className="py-12 sm:py-16 md:py-28 w-full"
      style={{
        background:
          'radial-gradient(circle at 82% 18%, rgba(50, 185, 232, 0.22), transparent 22rem), linear-gradient(135deg, #0c242c, #153944)',
      }}
    >
      <div className="container-site mx-auto">
        <div className="max-w-[860px] mx-auto p-6 md:p-12 rounded-card border border-white/15 bg-white/5 backdrop-blur-md shadow-[0_26px_80px_rgba(0,0,0,0.18)]">
          <p className="text-sm font-black uppercase tracking-wider text-signal mb-3">Baustellen-Assistent</p>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-white leading-tight mb-4">
            Die Anfrage ist schneller klar.
          </h2>
          <p className="text-white/80 text-base sm:text-lg leading-relaxed max-w-[680px] mb-6">
            Statt langer Nachricht fragt der Assistent nur die Punkte ab, die für die Rückmeldung wichtig sind:
            Leistung, Ort, Termin, Menge und Zufahrt.
          </p>
          <div className="flex flex-wrap gap-3">
            <Button onClick={openChat} variant="dark">
              <MessageSquare className="w-[18px] h-[18px]" />
              Assistent öffnen
            </Button>
            <Button href="mailto:office@mh-beton.at" variant="secondary">
              <Mail className="w-[18px] h-[18px]" />
              office@mh-beton.at
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AssistantSection;
